import { ArticleCommentsTopTabRenderProps } from "../articleCommentsTopTabWrapper";
import { getTalkbackNumberView } from "../../articleSocialShare1280Component/articleSocialShareNew1280";
import { getTranslation } from "../translations";

interface ArticleCommentsTopTabUI1280rops {
    props: ArticleCommentsTopTabRenderProps
}

export class ArticleCommentsTopTabAppUI2026 extends React.Component<ArticleCommentsTopTabUI1280rops, {}> {

    render() {
        const { numOfComments, lang } = this.props.props

        return (
            <div className="ArticleCommentsTopTabAppUI-pf">
                <div className="tabPanel">
                    <a key="newCommentBtn" className="newCommentBtn-pf" title="הוספת תגובה" href="add_new_comment">
                        <div className="btnText-pf">{getTranslation(lang, "New Comment(premium)")}</div>
                    </a>
                </div>

                <a className="tabTitle-pf" href="go_to_all_comments">
                    <span className="tbIcon-pf"></span>
                    <span className="com-pf">{getTalkbackNumberView(numOfComments.toString())} {getTranslation(lang, "Comments")}</span>
                </a>
            </div>
        )
    }
}